import { Indicator as RadixIndicator, Item as RadixItem } from '@radix-ui/react-radio-group';

import { Label } from '~/components/granular';
import { classNames } from '~/utils/styles';

import type { RadioGroupProps, RadioItem as RadioItemProps } from '../RadioGroup.types';

type ItemProps = RadioItemProps &
  Pick<RadioGroupProps, 'alignItems'> & {
    /** Applied to the option's outer row, e.g. to add a border in the group's bordered variant */
    className?: string;
  };

export const Item = ({
  id,
  label,
  value,
  appearance = 'light',
  alignItems = 'center',
  disabled,
  className,
}: ItemProps) => {
  const classes = classNames(
    'm-0.5 h-4 w-4 shrink-0 cursor-pointer appearance-none rounded-full border border-solid border-neutral-600 bg-white disabled:border-neutral-400 data-[state=checked]:border-teal-700 disabled:data-[state=checked]:border-neutral-400',
    { 'mt-0.5': alignItems === 'start' },
  );
  const indicatorClasses = classNames(
    'grid h-full w-full place-items-center after:block after:h-[10px] after:w-[10px] after:rounded-[50%] after:bg-teal-700 data-disabled:after:bg-neutral-400',
  );

  return (
    <div className={classNames('flex', alignItems === 'start' ? 'items-start' : 'items-center', className)}>
      <RadixItem className={classes} disabled={disabled} id={id} value={value}>
        <RadixIndicator className={indicatorClasses} />
      </RadixItem>
      <Label appearance={appearance} disabled={disabled} htmlFor={id}>
        {label}
      </Label>
    </div>
  );
};
